import axios from "../api";
// 本馆介绍
const get_museum_des = () =>
  axios(
    "/museum_des", {
    p: PLAT,
    museum_id: MID,
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );

// 馆内动态 新闻列表
const get_news_list = (data) =>
  axios(
    "/news/news_list", {
    p: PLAT,
    museum_id: MID,
    type: data.type,//新闻类别 1本馆新闻2工作动态
    page: data.page,
    limit: data.limit
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
// 动态详情
const get_news_detail = (news_id) =>
  axios(
    "/news/news_info", {
    p: PLAT,
    news_id
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
// 参观须知
const get_visit = () =>
  axios(
    "/museum_visit_info", {
    p: PLAT,
    museum_id: MID,
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
//获取文创列表
const get_cultureshop_list = (data) => {
  return axios(
    "/goods/goods_list", {
    p: PLAT,
    museum_id: MID,
    cate_id: data.cate_id,
    page: data.page,
    limit: data.limit
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
}
//获取文创详情
const get_goodsDetail_info = (goods_id) => {
  return axios(
    "/goods/goods_info", {
    p: PLAT,
    goods_id
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
}
export default {
  get_museum_des,
  get_news_list,
  get_news_detail,
  get_visit,
  get_cultureshop_list,
  get_goodsDetail_info
}


// WEBPACK FOOTER //
// ./src/http/modules/museum.js